import React from 'react';
import { ExerciseDestination } from '../../../student/mockLessonContent';

export type ExerciseLayout = 'mobile' | 'desktop';

export const ExerciseLayoutContext = React.createContext<ExerciseLayout>('mobile');

export function useExerciseLayout(): ExerciseLayout {
    return React.useContext(ExerciseLayoutContext);
}

// 'done'  — the student finished the exercise; Continue is enabled.
// 'skip'  — two failed attempts on a must-get-right exercise; Continue is
//           enabled and reads "Skip" until the exercise is done.
export type ReadyState = 'done' | 'skip';

export type ExerciseReady = (state?: ReadyState, destination?: ExerciseDestination) => void;
